// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.motion-app-width {
    width: 650px;
}

.motion-app-live-mode-width {
    width: 160px;
}

.motion-app-heading {
    text-align: center;
    margin: 5px;
}

.motion-app-input-field {
    width: 85px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/motion_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".motion-app-width {\n    width: 650px;\n}\n\n.motion-app-live-mode-width {\n    width: 160px;\n}\n\n.motion-app-heading {\n    text-align: center;\n    margin: 5px;\n}\n\n.motion-app-input-field {\n    width: 85px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
